import { render } from "./walletMenuIndex.vue?vue&type=template&id=3e2bb0e8"
import script from "./walletMenuIndex.vue?vue&type=script&lang=js"
export * from "./walletMenuIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__